import { Button, Form, Input, Modal, Select, Checkbox, Typography } from "antd";
import { useState } from "react";

import { selectFormOptionsNoFormatting } from "../../../../utils/helper";

const { Text } = Typography;

const CreateSubscriptionModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  handleCreate = () => {}
}) => {
  const [form] = Form.useForm();
  const [typeValue, setTypeValue] = useState(null);
  const [overrideLinkingPayment, setOverrideLinkingPayment] = useState(false);

  return (
    <Modal
      title="Create Subscription"
      centered
      open={isModalOpen}
      footer={[]}
      onOk={() => setIsModalOpen(false)}
      onCancel={() => setIsModalOpen(false)}
    >
      <Form
        form={form}
        name="new_subscription_form"
        onFinish={handleCreate}
        onValuesChange={(changedValues) => {
          if (changedValues.type) {
            setTypeValue(changedValues.type);
            form.validateFields();
          }
        }}
      >
        <Form.Item
          name="userEmail"
          label="User Email"
          rules={[
            { required: true, message: "Please enter the email!" },
            { type: "email", message: "Please enter a valid email!" }
          ]}
        >
          <Input placeholder="foo@bar.com" />
        </Form.Item>

        <Form.Item
          name="manualAdditionReason"
          label="Reason for Addition"
          rules={[{ required: true, message: "Please mention a valid reason!" }]}
        >
          <Input placeholder="some reason" />
        </Form.Item>

        <Form.Item
          name="type"
          label="Type"
          rules={[{ required: true, message: "Please select a subscription type!" }]}
        >
          <Select
            options={selectFormOptionsNoFormatting(["INTERNAL", "PURCHASE", "FREE_SLOT"])}
            showSearch
            allowClear
          />
        </Form.Item>

        {typeValue === "PURCHASE" && (
          <>
            <Form.Item>
              <Checkbox
                checked={overrideLinkingPayment}
                onChange={(e) => setOverrideLinkingPayment(e.target.checked)}
              >
                Override payment linking
              </Checkbox>
              {overrideLinkingPayment && (
                <Text type="danger" style={{ display: "block", marginTop: 4 }}>
                  Payment won&apos;t be linked to this order
                </Text>
              )}
            </Form.Item>

            {!overrideLinkingPayment && (
              <>
                <Form.Item
                  name="razorpayOrderId"
                  label="RazorPay Order ID"
                  rules={[
                    { required: true, message: "Please enter the RazorPay Order ID!" },
                    {
                      pattern: /^order_[a-zA-Z0-9]{14,}$/,
                      message: "Invalid RazorPay Order ID format!"
                    }
                  ]}
                >
                  <Input placeholder="order_XXXX" />
                </Form.Item>

                <Form.Item
                  name="razorpayPaymentId"
                  label="RazorPay Payment ID"
                  rules={[
                    { required: true, message: "Please enter the RazorPay Payment ID!" },
                    {
                      pattern: /^pay_[a-zA-Z0-9]{14,}$/,
                      message: "Invalid RazorPay Payment ID format!"
                    }
                  ]}
                >
                  <Input placeholder="pay_XXXX" />
                </Form.Item>
              </>
            )}
          </>
        )}

        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            Create Subscription
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateSubscriptionModal;
